/** Logic chọn đơn dùng chung cho Apply/Merge — tách khỏi UI để kiểm thử. */
export const MAX_SELECTION = 1000; // trần backend POST /apply-to-orders

export function addToSelection(
  prev: Set<number>,
  ids: number[],
  limit: number = MAX_SELECTION,
): { next: Set<number>; capped: boolean } {
  const next = new Set(prev);
  let capped = false;
  for (const id of ids) {
    if (next.has(id)) continue;
    if (next.size >= limit) { capped = true; break; }
    next.add(id);
  }
  return { next, capped };
}

/** Chặn submit khi đang gửi/đang tải, danh sách lỗi hoặc chưa chọn đơn. */
export function pickerBlocksSubmit(input: {
  submitting: boolean; loading: boolean; error: string; selectedCount: number;
}): boolean {
  return input.submitting || input.loading || input.error !== "" || input.selectedCount === 0;
}

/** Lần gửi đã cũ (modal được mở lại) thì không được tự đóng modal. */
export function isStaleRun(run: number, current: number): boolean {
  return run !== current;
}

/** Chỉ xoá NCC nguồn khi dời TOÀN BỘ đơn của nguồn và không đang lọc. */
export function shouldRetireSource(input: { query: string; selectedCount: number; total: number }): boolean {
  return !input.query && input.total > 0 && input.selectedCount === input.total;
}
